import React from 'react';
import PropTypes from 'prop-types';
import {t} from 'ttag';

import Page from '../page/page';
import EmptyBox from '../empty-box/empty-box';
import Text from '../text/text';
import Link from '../link/link';
import {useAppContext} from '../../app-context';

const ErrorPage = ({title}) => {
  const {whatsAppSupport} = useAppContext();

  return (
    <Page
      isCenter
      isTransparent
    >
      <EmptyBox title={title}>
        <Text color="dark">
          {t`Contact us on`}
          {' '}
          <Link
            href={whatsAppSupport}
            target="_blank"
          >
            WhatsApp
          </Link>{' '}
          {t`or`}
          {' '}
          <Link
            href="https://t.me/whatcrmbot"
            target="_blank"
          >
            Telegram
          </Link>
          .
        </Text>
      </EmptyBox>
    </Page>
  );
};

ErrorPage.propTypes = {
  title: PropTypes.string
};

ErrorPage.defaultProps = {
  title: ''
};

export default ErrorPage;
